import { PermissionConstant } from '../constants';
import { RequestAction } from '.';

export const getPermissions = params =>
  RequestAction.request(PermissionConstant.GET_PERMISSIONS, {
    params,
    url: '/api/permission',
  }, false);

export const setPermissions = payload => ({
  payload,
  type: PermissionConstant.SET_PERMISSIONS,
});
